import { useActions, useApiActions } from "state/hooks";
import { handleBrowserUpload } from "state/actions/upload";

import {
    createDirectory,
    deleteDirectory,
    importMedia,
    saveMedia,
    syncMedia,
    selectMedia,
    deleteMedia,
} from "state/actions/media";

export function useMediaActions() {
    const apiActions = useApiActions({
        onUploadMedia: handleBrowserUpload,
        onDeleteMedia: deleteMedia,
        onCreateDirectory: createDirectory,
        onDeleteDirectory: deleteDirectory,
        onImportMedia: importMedia,
        onSyncMedia: syncMedia,
        onSaveMedia: saveMedia,
    });
    const { onSelect } = useActions({
        onSelect: selectMedia,
    });

    return { ...apiActions, onSelect };
}
